import React from 'react';

export const AnimatedBackground: React.FC = () => {
  return (
    <div className="fixed inset-0" style={{ background: '#0A0A0A' }}>
      {/* Subtle grid — barely visible, adds texture without distraction */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.025) 1px, transparent 1px),
                            linear-gradient(to bottom, rgba(255,255,255,0.025) 1px, transparent 1px)`,
          backgroundSize: '5rem 5rem',
          maskImage: 'radial-gradient(ellipse at 50% 0%, black 30%, transparent 75%)',
          WebkitMaskImage: 'radial-gradient(ellipse at 50% 0%, black 30%, transparent 75%)',
        }}
      />
      {/* Single very subtle warm glow at top-center — like a stadium light far away */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] rounded-full"
        style={{ background: 'rgba(217,48,37,0.04)', filter: 'blur(80px)' }}
      />
    </div>
  );
};
